<template>
  <v-dialog
    v-model="removeFolderDialog"
    persistent
    max-width="300"
  >
    <v-card>
      <v-card-text>
        Remover este processo da lista de processos apensados?
      </v-card-text>

      <v-card-actions>
        <v-btn flat @click="cancel" class="mx-2">
          <v-icon color="red">mdi-block-helper</v-icon>
        </v-btn>
        <v-spacer></v-spacer>
        <v-btn flat @click="removeFolder" class="mx-2">
          <v-icon color="green">mdi-check</v-icon>
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: 'RemoveFolderDialog',
  props: ['folder'],
  data() {
    return {
      removeFolderDialog: true,
    }
  },
  methods: {
    removeFolder() {
      this.$emit('removeFolder', this.folder);
    },
    cancel() {
      this.removeFolderDialog = false;
      this.$emit('cancel');
    }
  }
}
</script>


// WEBPACK FOOTER //
// src/components/folder/show/toolbar/action/RemoveFolderDialog.vue